import { apiClient } from "./client";

export const agencyDashboardApi = {
  getMetrics: async () => (await apiClient.get("/agencies/dashboard/")).data,
};

export const orgSettingsApi = {
  get: async () => {
    const { data } = await apiClient.get("/agencies/settings/");
    return data;
  },

  update: async (changes) => {
    const { data } = await apiClient.patch("/agencies/settings/", changes);
    return data;
  },
};
